// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__X2tEv","Label":"Input_Label__G6Vvm","InputElement":"Input_InputElement__24EkW","Invalid":"Input_Invalid__2addj"};